import React from "react";
import { TbCheck } from "react-icons/tb";
import { PlanCard, CustomButton, CustomLoader } from "../../../../components";
import { CUSTOM_PLAN, formatCurrency } from "../pricingData";
import styles from "../Pricing.module.css";

const Step1SelectPlan = ({
  plans,
  loading,
  error,
  selectedPlanId,
  selectedSlabByPlan,
  onSelectPlan,
  onSlabChange,
  onCompareFeatures,
  onProceed,
  onContactSales,
}) => {
  return (
    <div>
      {loading && (
        <div className={styles.compareStateWrap}>
          <CustomLoader text="Loading plans..." />
        </div>
      )}

      {!loading && error && (
        <div className={styles.compareStateWrap}>
          <p className={styles.compareErrorText}>{error}</p>
        </div>
      )}

      {!loading && !error && (
        <div className={styles.planGrid}>
   {plans.map((plan) => {
  const isSelected = selectedPlanId === plan.id;

  const selectedTier = isSelected
    ? plan.slabs.find((s) => s.id === selectedSlabByPlan[plan.id]) || plan.slabs[0]
    : null;

  const displayTier = selectedTier || plan.slabs[0];

  return (
    <div
      key={plan.id}
      className={styles.planGridItem}
      onClick={() => onSelectPlan(plan.id)}
    >
      <PlanCard
        planName={plan.planName}
        badgeText={plan.badgeText}
        badgeVariant={plan.badgeVariant}
        priceLabel={plan.priceLabel}
        price={displayTier?.price.split("/")[0] || ""}
        billingCycle={plan.billingCycle}
        subText={
          displayTier?.maxUsers
            ? `for up to ${displayTier.maxUsers} users (students & staff)`
            : ""
        }
        description={plan.description}
        billingNote={plan.billingNote}
        slabTitle="Slab Pricing by Users"
        slabs={plan.slabs}
        selectedSlabId={selectedTier?.id ?? null}
        onSlabChange={(slabId) => onSlabChange(plan.id, slabId)}
        includes={plan.includes}
        amc={{
          label: "Subsequent Year AMC Around",
          price: formatCurrency(displayTier?.amcPrice),
          includes: plan.amcIncludes,
        }}
        highlighted={isSelected}
      />
    </div>
  );
})}
        </div>
      )}

      <div className={styles.actionsRow}>
        <CustomButton
          variant="outline-primary"
          fullWidth={false}
          rounded
          className={styles.outlineBtn}
          onClick={onCompareFeatures}
        >
          Compare Features
        </CustomButton>
        <CustomButton
          variant="primary"
          fullWidth={false}
          rounded
          className={styles.proceedBtn}
          onClick={onProceed}
        >
          Proceed
        </CustomButton>
      </div>

      <div className={styles.customPlanCard}>
        <h3 className={styles.customPlanTitle}>{CUSTOM_PLAN.title}</h3>
        <p className={styles.customPlanDescription}>
          {CUSTOM_PLAN.description}
        </p>

        <span className={styles.customPlanIncludesTitle}>INCLUDES</span>
        <ul className={styles.customPlanIncludesList}>
          {CUSTOM_PLAN.includes.map((item) => (
            <li key={item} className={styles.customPlanIncludesItem}>
              <TbCheck className={styles.customPlanIncludesIcon} />
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <CustomButton
          variant="primary"
          fullWidth={false}
          className={styles.contactSalesBtn}
          onClick={onContactSales}
        >
          {CUSTOM_PLAN.ctaText}
        </CustomButton>
      </div>
    </div>
  );
};

export default Step1SelectPlan;
